'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _spec = require('../spec');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  row: {
    'box-sizing': 'border-box',
    display: 'flex',
    flex: '0 1 auto',
    'flex-direction': 'row',
    'flex-wrap': 'wrap'
  },
  reverse: {
    'flex-direction': 'row-reverse'
  }
};

var helpers = {
  start: {
    'justify-content': 'flex-start',
    'text-align': 'start'
  },
  center: {
    'justify-content': 'center',
    'text-align': 'center'
  },
  end: {
    'justify-content': 'flex-end',
    'text-align': 'end'
  },
  top: { 'align-items': 'flex-start' },
  middle: { 'align-items': 'center' },
  bottom: { 'align-items': 'flex-end' },
  around: { 'justify-content': 'space-around' },
  between: { 'justify-content': 'space-between' }
};

Object.keys(_spec.breakpoints).forEach(function (breakpoint) {
  Object.keys(helpers).map(function (key) {
    return { key: key, helper: helpers[key] };
  }).forEach(function (_ref) {
    var key = _ref.key,
        helper = _ref.helper;

    styles[breakpoint + '-' + key] = _defineProperty({}, (0, _spec.media)(breakpoint), helper);
  });
});

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ../dist/row/styles.js
// module id = 127
// module chunks = 0